import Link from "next/link";

import Multimedia from "@sharedComponents/multimedia";

import stadiumLogo from "@images/svg/stadium-logo.svg";

export default function ErrorComponent() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <section className="text-center">
        <div className="container">
          <Link href={"/"} passHref legacyBehavior>
            <div className="p-3 mb-5 position-relative cursor-pointer">
              <Multimedia type="image" src={stadiumLogo} layout="fill" />
            </div>
          </Link>

          <h2 className="jumbotron-heading text-theme-primary">Something went wrong!</h2>
          <p className="lead text-muted mb-5">
            Our team has been notified. Meanwhile, you may refresh the page or try again.
          </p>
        </div>
      </section>
    </div>
  );
}
